import React, { useEffect } from 'react';
import { uniqueId } from 'lodash';
import {
  StyledTabs,
  StyledTab,
  FeeNoteButton,
} from 'components/LegalProceedingTabs/style';
import CoreButton from 'components/Buttons/CoreButton';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import feeNoteIcon from 'images/fee-note-icon.svg';
import AssignmentIcon from 'images/assignment-icon.svg';
import IconInstruction from 'images/icon-instruction.svg';
import EmptyIconInstruction from 'images/empty-icon-instruction.svg';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { isInstructionsRead } from 'containers/CourtManagerLegalProceedings/InstructionDrawer/utils';

export interface LegalProceedingTabsProps {
  children?: React.ReactNode[] | React.ReactNode;
  labels: string[];
  currentTabIndex: number;
  onTabClick?: Function;
  setCurrentInstanceTab?: Function;
  onPressFeeNote?: () => void;
  onPressAssignment?: () => void;
  onPressInstructions?: () => void;
  isAssignedLawyer?: boolean;
  instructions?: any;
  isIntervenants?: boolean;
}

const LegalProceedingTabs: React.FC<LegalProceedingTabsProps> = (
  props,
): JSX.Element => {
  const {
    currentTabIndex,
    children,
    labels,
    onTabClick,
    setCurrentInstanceTab,
  } = props;

  const [currentTab, setCurrentTab] = React.useState<number>(currentTabIndex);
  useEffect(() => {
    if (onTabClick) onTabClick(currentTab);
    setCurrentTab(currentTabIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabIndex, onTabClick]);

  const handleChangeTab = (event: React.ChangeEvent<{}>, newTab: number) => {
    if (onTabClick) onTabClick(currentTab);
    else if (setCurrentInstanceTab) setCurrentInstanceTab(newTab);
    setCurrentTab(newTab);
  };

  return (
    <>
      <StyledTabs value={currentTab} onChange={handleChangeTab}>
        {React.Children.toArray(children).map((_, index) => (
          <StyledTab key={uniqueId('sahamtab')} label={labels[index]} />
        ))}
        <div className="button-container">
          {featureService.hasFeature(FEATURES.INSTRUCTIONS) &&
            (userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) ||
              userPrivileges.userHasPrivilege(
                PRIVILEGES.ISCONSULTATIONMANAGER,
              ) ||
              props.isAssignedLawyer) &&
            props.onPressInstructions && (
              <CoreButton
                className="instruction"
                title={'Messagerie'}
                titleclass={'title-class'}
                onClick={props.onPressInstructions}
                lefticon={
                  <img
                    src={
                      isInstructionsRead(
                        props.instructions,
                        props.isIntervenants,
                      )
                        ? EmptyIconInstruction
                        : IconInstruction
                    }
                    alt="instructionsIcon"
                  />
                }
              />
            )}

          {(userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER) ||
            userPrivileges.userHasPrivilege(
              PRIVILEGES.ISCONSULTATIONMANAGER,
            )) &&
            props.onPressFeeNote && (
              <>
                <FeeNoteButton>
                  <CoreButton
                    className="drop-down-button"
                    title={'Affectation'}
                    titleclass={'title-class'}
                    onClick={props.onPressAssignment}
                    lefticon={<img src={AssignmentIcon} alt="FeeNoteIcon" />}
                  />

                  <CoreButton
                    className="drop-down-button"
                    title={"Note d'honoraires"}
                    titleclass={'title-class'}
                    onClick={props.onPressFeeNote}
                    lefticon={<img src={feeNoteIcon} alt="FeeNoteIcon" />}
                  />
                </FeeNoteButton>
              </>
            )}

          {featureService.hasFeature(FEATURES.EVOLUTION_P3) &&
            props.isAssignedLawyer &&
            props.onPressFeeNote && (
              <>
                <FeeNoteButton>
                  <CoreButton
                    className="drop-down-button"
                    title={"Note d'honoraires"}
                    titleclass={'title-class'}
                    onClick={props.onPressFeeNote}
                    lefticon={<img src={feeNoteIcon} alt="FeeNoteIcon" />}
                  />
                </FeeNoteButton>
              </>
            )}
        </div>
      </StyledTabs>
      {React.Children.toArray(children)[currentTab]}
    </>
  );
};

export default LegalProceedingTabs;
